


























































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Color,
  Flg,
  SumiFlg,
} from '@/constants/constants';
import { getDefaultPagerInfo } from '@/utils/utils';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import '../../../src/assets/scss/activeReportsJS/ar-js-ui.css';
import '../../../src/assets/scss/activeReportsJS/ar-js-viewer.css';
import G_140_HaisoIrai_Renraku from '@/components/G_kaigai/G_140_HaisoIrai_Renraku.vue';

const TYPES = {
  SHUKKO: '出庫',
  HAISO: '配送',
};

export default Vue.extend<any, any, any, any>({
  name: 'G_140_HaisoIrai_Table',
  components: {
    CtrlMessageDialog,
    G_140_HaisoIrai_Renraku,
  },
  props: {
    kakuteiSumiFlg: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    Color,
    SumiFlg,
    Flg,
    TYPES,
    headers: [
      {
        text: 'ｵｰﾀﾞｰ№',
        value: 'orderNo',
        sortable: true,
        width: 95,
      },
      {
        text: '出荷予定日',
        value: 'shukkaYoteiYmd',
        sortable: true,
        width: 115,
      },
      {
        text: '納品予定日',
        value: 'nohinYoteiYmd',
        sortable: true,
        width: 115,
      },
      {
        text: '出荷倉庫',
        value: 'shukkaSokoMei',
        sortable: true,
        width: 256,
      },
      {
        text: '配送会社',
        value: 'haisoKaishaMei',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        sortable: true,
        width: 340,
      },
      {
        text: '得意先',
        value: 'tokuisakiMei',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        sortable: true,
        width: 340,
      },
      {
        text: '納品先',
        value: 'nohinsakiMei',
        sortable: true,
        width: 450,
      },
      {
        text: '納品先住所',
        value: 'nohinsakiAddress',
        sortable: true,
        width: 800,
      },
      {
        text: '品目（1件目）',
        value: 'himmokuMei',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        sortable: true,
        width: 400,
      },
      {
        text: 'c/s数量計',
        value: 'suryoSum',
        sortable: true,
        width: 115,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: 'バラ数量計',
        value: 'hasuSum',
        sortable: true,
        width: 115,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: '重量計',
        value: 'juryoSum',
        sortable: true,
        width: 115,
        class: 'text-end',
        cellClass: 'text-end',
      },
      { text: '', value: 'action', sortable: false, width: 200 },
    ],
    footerProps: {},
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    messageShow: false,
    messageId: '',
    messageTextParam: [],
    isClearTable: false,
    isReload: false,

    selectItem: null,
    showRenraku: false,
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
    tableHeight() {
      return this.$vuetify.breakpoint.height - 390;
    },
    itemsDisp() {
      return this.kakuteiSumiFlg
        ? this.items
        : this.items.filter((item: any) => item.kakuteiSumiFlg === SumiFlg.MI);
    },    
    showSelect() {
      return this.itemsDisp.some(
        (item: any) => item.kakuteiSumiFlg === SumiFlg.MI
      );
    },
    localState: {
      get() {
        return this.selected;
      },
      set(value: any) {
        this.$emit('update:selected', value);
      },
    },
  },
  methods: {
    customSearch(_value: any, search: string | null, item: any) {
      const filterValues = [
        item['orderNo'],
        item['nohinYoteiYmd'],
        item['shukkaYoteiYmd'],
        item['shukkaSokoMei'],
        item['haisoKaishaMei'],
        item['tokuisakiMei'],
        item['nohinsakiMei'],
        item['nohinsakiAddress'],
        item['himmokuMei'],
      ];

      return filterValues.some(
        (v: any) =>
          v &&
          v
            .toString()
            .toLowerCase()
            .includes(search ? search.toLowerCase() : '')
      );
    },
    customClassTable(item: any) {
      let classes = '';
      
      if (item.kakuteiSumiFlg == SumiFlg.SUMI)
      {
        classes = 'grey-flag';
      }
      else if (item.changeFlg == SumiFlg.SUMI)
      {
        classes = 'orange-flag';
      }
      return classes;
    },
    // 備考を起動
    async handleRenraku(item: any) {
      this.selectItem = item;
      this.showRenraku = true;
    },
    // 備考を閉じる
    handleCloseRenraku() {
      this.showRenraku = false;
    },
    handleOkMessage() {
      this.messageShow = false;
      this.messageId = '';
      this.messageTextParam = [];
      if (this.isClearTable) {
        this.isClearTable = false;
        this.$emit('clear-table');
      }
      if (this.isReload) {
        this.isReload = false;
        this.$emit('reload');
      }
    },
  },
  mounted() {
    const pagerInfo = getDefaultPagerInfo();
    this.footerProps = pagerInfo.footerProps;
    this.options.itemsPerPage = pagerInfo.itemPerPage;
  },
});
